import React, { createContext, ReactNode } from 'react';
import { IModalContext } from './models/IModalContext.ts';

export const ModalContext = createContext<IModalContext>({
    isOpen: false,
    isBackButtonVisible: false,
    closeModal(): void {
    },
    showModal(header: React.ReactNode, content: React.ReactNode, maxHeightDesktop?: string | undefined, maxWidthDesktop?: string | number | undefined, actionButton?: ReactNode, onClose?: VoidFunction): void {
        header;
        content;
        maxHeightDesktop;
        maxWidthDesktop;
        actionButton;
        onClose?.();
    },
    setIsBackButtonVisible(isVisible: boolean): void {
        isVisible;
    },
    setBackButtonAction(action: (() => void) | undefined): void {
        action;
    },
});